import { SvgIcon } from "@mui/material"

import { ReactComponent as Stabilo } from "./Stabilo.svg"

export const StabiloIcon = (props) => {
    return (
        <SvgIcon component={Stabilo} {...props} inheritViewBox />
    )
}
